/**
 * @flow
 */
import React, { Component } from 'react'
import { IcHeart } from '../../../../Icons'
import {
  TestimonialTitleContainer,
  TestimonialHeading,
  IconContainer
} from './styledComponents.js'

class TestimonialTitle extends Component {
  render() {
    return (
      <TestimonialTitleContainer>
        <TestimonialHeading as="h2">PEOPLE</TestimonialHeading>
        <IconContainer>
          <IcHeart />
        </IconContainer>
        <TestimonialHeading>iB CRICKET!</TestimonialHeading>
      </TestimonialTitleContainer>
    )
  }
}

export default TestimonialTitle



// WEBPACK FOOTER //
// ./src/components/IbcArcade/TestimonialSection/TestimonialTitle/index.js